export default {
  'Choose File': 'ファイルを選択する',
  'Please paste a URL': 'URLを入力してください',
  'Loading': '読み込み中',
  'Analyzing': '解析中',
  'Try a sample': 'サンプルをお試しください',
  'Sorry, error occurs when analyzing the URL.': '申し訳ありません。URLの解析時にエラーが発生しました。',
  'Upload a photo': '写真をアップロードする',
  "Drag and drop files to the upload box.": 'アップロードボックスにファイルをドラッグ＆ドロップしてください。',
  'Please select the proper position with portrait.': 'ポートレートで適切な位置を選択してください',
  'downloading': 'ダウンロード',
}